export interface Labeling {
  addButton?: string;
  cancelButton?: string;
  deleteButton?: string;
  okButton?: string;
  saveButton?: string;
  copyButton?: string;
  importButton?: string;
  tableHeaderSortBy?: string;
  sortAscending?: string;
  sortDescending?: string;
  noRowsMessage?: string;
  entityName?: string;
  entityNamePlural?: string;
  unassignedGroupLabel?: string;
  entityLabel?: string;
  addShortcutTooltip?: string;
  hideLabel?: boolean;
}
